import { Mascot } from "@/components/brand/Mascot";

export const Wordmark = ({ dark = false, variant = "horizontal", size = "md", mascot = true }) => {
  if (size === "xl")
    return (
      <span className="flex items-center gap-2.5 lg:gap-3 xl:gap-4">
        {mascot && <Mascot size={64} label="" className="h-auto w-10 shrink-0 sm:w-11 lg:w-12 xl:w-16" />}
        <span className="flex flex-col items-start leading-none">
          <span className={`whitespace-nowrap font-display text-[30px] lowercase tracking-[-0.01em] sm:text-[36px] lg:text-[42px] xl:text-[54px] ${dark ? "text-cloud" : "text-ink"}`}>the suspects</span>
          <span className={`mt-1 whitespace-nowrap font-a text-[7px] tracking-[0.2em] sm:text-[8px] xl:mt-1.5 xl:text-[9px] ${dark ? "text-cloud/40" : "text-concrete"}`}>CERTIFIED SUS</span>
        </span>
      </span>
    );
  const lg = size === "lg";
  const stacked = variant === "stacked";
  return (
    <span className={`flex ${stacked ? "flex-col items-center gap-2.5" : "items-center gap-2.5"}`}>
      {mascot && <Mascot size={stacked ? (lg ? 58 : 42) : lg ? 42 : 32} label="" className="shrink-0" />}
      <span className={`flex flex-col leading-none ${stacked ? "items-center" : "items-start"}`}>
        <span className={`font-display lowercase tracking-[-0.01em] ${lg ? "text-4xl" : "text-[25px] sm:text-[27px]"} ${dark ? "text-cloud" : "text-ink"}`}>the suspects</span>
        <span className={`mt-1 font-a text-[7px] tracking-[0.2em] ${dark ? "text-cloud/40" : "text-concrete"}`}>CERTIFIED SUS</span>
      </span>
    </span>
  );
};
